import React from 'react'
import Session from "../helpers/Session";
import Api from "../helpers/Api";
import Env from "../config/env";
import AppToast from "../ui/AppToast";
import Cuentas from "./pqr/Cuentas";
import AssociateAccount from "./pqr/AssociateAccount";
import Redirect from "../helpers/Redirect";
import CuentaSelected from "../helpers/CuentaSelected";
import {withRouter} from 'react-router';
import FiltrosApi from "../helpers/FiltrosApi";
import AlertPrivacyPolicy from "./administration/AlertPrivacyPolicy";
import SpeedDial from '@material-ui/lab/SpeedDial';
import AddIcon from "@material-ui/icons/Add";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import Icon from "@material-ui/core/Icon";
import AlertDataTreatment from "./administration/AlertDataTreatment";
//------//
// import Fab from "@material-ui/core/Fab";
// import Tooltip from "@material-ui/core/Tooltip";

class Home extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            cuentas: [],
            validateDigital: [],

            open: false,
            url: '',
            openModal: false,
            openModalTD: false,
            openSpeedDial: false,
        }

        this.getCuentas = this.getCuentas.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleGrandesClientes = this.handleGrandesClientes.bind(this);
    }


    async componentDidMount() {
        const userData = Session.getLogin();

        if (userData) {
            this.getCuentas(userData);
        }

    }

    getCuentas = async (userData) => {

        const data = await Api.get(`${Env.UrlBackend}/privacy-policy/get-accounts?terceroID=${userData.terceroID}&email=${userData.terceroMail}`,);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({
            cuentas: data.data,
            validateDigital: data.validateDigital,
            // pagoTransito: data.pagoTransito
        });
        FiltrosApi.set(data.filtros)

        if (data.agreePP === 'N') {
            this.setState({openModal: true});
        }

        if (data.agreeTD === 'N') {
            this.setState({openModalTD: true});
        }
    }

    handleCloseModal = () => {
        this.setState({openModal: false});
    }

    handleCloseModalTD = () => {
        this.setState({openModalTD: false});
    }

    handleSelectedAccount = (obj) => {
        CuentaSelected.set(obj);
        this.setState({
            url: '/menu'
        });
    }

    handleGrandesClientes = (obj) => {
        CuentaSelected.set(obj);
        this.setState({
            url: '/big-clients'
        });
    }

    handleOpenDialog = () => {
        this.setState({
            open: true,
        })
    }

    handleCloseDialog = () => {
        this.setState({
            open: false,
        });
    }

    handleCuentaNueva = () => {
        this.setState({
            url: '/new-account-list'
        });
    }

    handleInscripcionProveedores = () => {
        this.setState({
            url: '/provider-registration-list'
        });
    }

    handleCloseSpeedDial = () => {
        this.setState({
            openSpeedDial: false
        });
    };

    handleOpenSpeedDial = () => {
        this.setState({
            openSpeedDial: true
        });
    };

    render() {

        return (
            <div style={{textAlign: 'center', paddingLeft: '30px', paddingRight: '30px'}} className='container-form'>

                <Redirect url={this.state.url}/>

                <h2>Cuentas</h2>

                <Cuentas
                    cuentas={this.state.cuentas}
                    validateDigital={this.state.validateDigital}
                    // pagoTransito={this.state.pagoTransito}
                    onChange={this.handleSelectedAccount}
                    getCuentas={this.getCuentas}
                    handleGrandesClientes={this.handleGrandesClientes}
                />

                <br/>

                <AssociateAccount
                    open={this.state.open}
                    onClose={this.handleCloseDialog}
                    getCuentas={this.getCuentas}
                />

                <AlertPrivacyPolicy
                    executeAPI={true}
                    openModal={this.state.openModal}
                    onCloseModal={this.handleCloseModal}
                />

                <AlertDataTreatment
                    executeAPI={true}
                    openModal={this.state.openModalTD}
                    onCloseModal={this.handleCloseModalTD}
                />

                
                    {/* 
                    <Tooltip title="Vincular una cuenta">
                        <Fab onClick={this.handleOpenDialog} color="primary" aria-label="add" className='float-button'>
                            <AddIcon/>
                        </Fab>
                    </Tooltip>
                    */}
                
                <SpeedDial
                    className='float-button-speed-dial'
                    ariaLabel="SpeedDial tooltip example"
                    icon={<SpeedDialIcon/>}
                    onClose={this.handleCloseSpeedDial}
                    onOpen={this.handleOpenSpeedDial}
                    open={this.state.openSpeedDial}
                >

                    <SpeedDialAction
                        key={1}
                        icon={<Icon>fact_check</Icon>}
                        tooltipTitle='Radicación Cuentas Nuevas'
                        title='Radicación Cuentas Nuevas'
                        tooltipOpen
                        onClick={this.handleCuentaNueva}/>

                    <SpeedDialAction
                        key={2}
                        icon={<AddIcon/>}
                        tooltipTitle='Vincular Cuenta'
                        title='Vincular Cuenta'
                        tooltipOpen
                        onClick={this.handleOpenDialog}/>

                    <SpeedDialAction
                        key={3}
                        icon={<Icon>people</Icon>}
                        tooltipTitle='Inscripción de proveedores'
                        title='Inscripción de proveedores'
                        tooltipOpen
                        onClick={this.handleInscripcionProveedores}/>

                </SpeedDial>

            </div>
        );
    }
}

export default withRouter(Home)
